<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.jpg" width="100%"  />
	</div>
</div>

<div class="wapper overf">
	<div class="part main-box2" style="background:#fff; padding:50px;">
        
        <div class="tit3"><em><a @click="goHome">返回首页>>  </a></em><span>我要举报</span></div>
        <div class=" t-center m_t_50">
              <a @click="notice(areaCode)" ><div class="button button-large  " style="background:url(static/img/sz_btn_bk.png) left top no-repeat; width:240px; height:110px; " >{{areaName}}委组织部<br />12380举报网站</div></a>
        </div>
        <div id="sz_btn">
                    <a @click="notice(item.areaCode)" v-for="(item,index)  in areaCodeList"> <div class="button button-large szbk"  >{{item.areaCity}}委组织部<br />12380举报网站</div></a>
        
        </div>
    </div>
</div>

<div class="clear overf m_t_40"></div>
<!---- foot ---->
<div class="wapper overf p_b_10" style="background:#AD0C1D;" >
  <div class="part p_t_20 h26 cWhite f14 overf" >
	  <div class="t-center">	
            <p class=" p_l_10 ">
                Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
			</p><p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
     </div>
</div>
</div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      areaCode :'',
      areaName :'',
      areaCodeList :[],
    }
  },
    mounted(){
    this.areaCode=this.$route.params.areaCode
     this.areaName=this.$route.params.areaName
	this.init()
  },
  methods:{
     init(){
  		request({
			url: '/area/list-by-parent/'+this.areaCode||'1018',
			method: 'get'
 		}).then(res => {
			this.areaCodeList = res.data.filter( (item,i) =>{
            return item.areaCity!='昭山'&&item.areaCity!='经开区'&&item.areaCity!='南湖风景区'&&item.areaCity!='屈原管理区'&&item.areaCity!='洪江区'
          } );
           this.areaCodeList.map((it,j)=>{ 
             if(it.areaCity=='宁乡县'){
               it.areaCity='宁乡市'
             }
              if(it.areaCity=='株洲县'){
               it.areaCity='渌口区'
             }  if(it.areaCity=='邵东县'){
               it.areaCity='邵东市'
             }
               if(it.areaCity=='南县'){
               it.areaCity='南县县'
             }
               if(it.areaCity=='道县'){
               it.areaCity='道县县'
             }
          })
        });
       
	  },
      notice(code){
          this.$router.push({name:'notice',params:{areaCode:code}})
      },
      goHome(){
          this.$router.push({name:'index'})
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#sz_btn{ width:90%; display:block; margin:0 auto; text-align:center;}
#sz_btn a{ display:inline-block; margin:25px; }
#sz_btn .szbk{background: url(../../static/img/sz_btn_bk2.png) left top no-repeat; width:185px; height:85px; line-height:30px; font-size:16px; color:#333; padding:8px 0;}
#sz_btn a:hover .szbk{ color:#fff; background:url(../../static/img/xq_btn_bk2.png) left top no-repeat;}

</style>



// WEBPACK FOOTER //
// src/views/county.vue